// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvailableMeals_meals__1Smrp","meals-appear":"AvailableMeals_meals-appear__rIX2h"};